import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

//Servicios
import {
    AuthService,
    BodegasService,
    ResendEmailService,
    SettingsService,
    UserWaitingHabilitationService,
    ViniedoService,
} from '../../services/api';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Componentes
import Login from './Login';
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import RoutesApp from '../../routes';

function LoginContainer() {
    const {
        setToken,
        setUser,
        setViniedos,
        setUsersForHabilitation,
        setSettings,
        setGrapesVariety,
        setBodegas,
    } = useGlobalContext();
    const [loader, setLoader] = useState(false);
    const [questionModal, setQuestionModal] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const { register, handleSubmit, setError, formState } = useForm();

    let navigate = useNavigate();

    const onSubmit = async (formData) => {
        try {
            setLoader(true);

            let response = await AuthService.login(formData);

            const {
                data,
                data: { confirmado, habilitado },
            } = response;

            if (!confirmado) {
                setQuestionModal(true);
                setUser(data);
                setToken(data.token);
                setModalMessage(
                    <form
                        onSubmit={handleSubmit(async (formData) => {
                            // console.log(data)
                            try {
                                setLoader(true);

                                const res = await ResendEmailService.send({
                                    token: data.token,
                                    correo: formData.correo,
                                });

                                setOpenModal(false);

                                setLoader(false);

                                toast(res.data, { type: 'success' });
                            } catch (err) {
                                toast('El mail no pudo ser enviado', {
                                    type: 'error',
                                });
                                setLoader(false);
                            }
                        })}
                    >
                        <p>
                            Por favor valide primero su cuenta de correo{' '}
                            <input
                                type="email"
                                {...register('correo', { value: data.correo })}
                            />
                            . Verifique su casilla de entrada, por un correo de
                            validación proveniente de INAVI.
                        </p>
                        <button className="btn btn-primary" type="submit">
                            Reenviar Correo
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={() => setOpenModal(false)}
                        >
                            Cancelar
                        </button>
                    </form>
                );
                setOpenModal(true);
            }

            if (confirmado && habilitado === 0) {
                setQuestionModal(false);
                setModalMessage(
                    'Su usuario aún no ha sido habilitado por INAVI'
                );
                setOpenModal(true);
            }

            if (response && data && confirmado && habilitado === 2) {
                window.sessionStorage.setItem('token', data.token);
                setToken(data.token);
                window.sessionStorage.setItem('user', JSON.stringify(data));
                setUser(data);

                if (data.tipo === 3) {
                    try {
                        const usersForHabilitation =
                            await UserWaitingHabilitationService.all({
                                token: data.token,
                            });

                        if (usersForHabilitation) {
                            setUsersForHabilitation(usersForHabilitation.data);
                        }
                    } catch (err) {
                        setLoader(false);
                        return err;
                    }
                }

                if (data.tipo !== 3) {
                    const viniedos = await ViniedoService.all({
                        token: data.token,
                        usuarioId: data.id,
                    });

                    if (viniedos) {
                        setViniedos(viniedos.data);
                    }
                }

                const settingsData = await SettingsService.all({
                    token: data.token,
                });

                if (settingsData) {
                    setSettings(settingsData.data);
                }

                const grapesVarietyData = await ViniedoService.grapesVariety({
                    token: data.token,
                });

                if (grapesVarietyData) {
                    setGrapesVariety(grapesVarietyData.data);
                }

                const Bodegas = await BodegasService.all({
                    token: data.token,
                });

                if (Bodegas) {
                    setBodegas(Bodegas.data);
                }

                navigate(RoutesApp.Home);
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <>
            <Login
                functions={{
                    register,
                    handleSubmit,
                    setError,
                    formState,
                    onSubmit,
                }}
                states={{}}
            />
            <Modal
                isOpen={openModal}
                onClose={() => setOpenModal(!openModal)}
                questionModal={questionModal}
            >
                {modalMessage}
            </Modal>
        </>
    );
}

export default LoginContainer;
